import { SvgFactory } from '../../Svg';

const CheckMarkIcon = SvgFactory(
    <svg viewBox='0 0 23 18' fill='black' xmlns='http://www.w3.org/2000/svg'>
        <path d='M22.9299 2.71338L20.2357 0L7.64331 12.5924L2.71338 7.68153L0 10.3758L7.64331 18L22.9299 2.71338Z' />
    </svg>,
);

export default CheckMarkIcon;
